import type { TLanguage } from '@semios/app-platform-i18n-core'
import type { V3AlertOnly } from '../_types'
import { AlertsSettings } from '../settings/alertSettings'
import type { AlertsResponse } from './useAlerts'

export const shapeLegacyAlertV3Alerts = (response: AlertsResponse): V3AlertOnly[] => {
  if (!response) {
    return []
  }

  let v3Alerts: V3AlertOnly[] = []

  if (response.legacyV3Alerts) {
    v3Alerts = Object.values(response.legacyV3Alerts).map((alert) => {
      return {
        id: alert.alertId,
        name: alert.name,
        type: {
          id: alert.alertType,
        },
        rules: Object.values(alert.alertRules).map((rule) => ({
          key: rule.key,
          operator: rule.operator,
          unit: rule.unit ?? undefined,
          value: rule.value,
        })),
        properties: alert.propertyIds?.map((id) => ({ id })) ?? [],
        blocks: alert.blockIds?.map((id) => ({ id })) ?? [],
        stations: alert.stationGeoms?.map((geom) => ({ geom })) ?? [],
        contacts: Object.values(alert.contacts).map((contact) => ({
          id: contact.contactId,
          name: contact.name,
          email: contact.email,
          sms: contact.sms,
          language: contact.language as TLanguage,
          alertsContactMethods: [
            contact.contactViaEmail ? 'email' : null,
            contact.contactViaSMS ? 'sms' : null,
          ].filter((cm): cm is 'email' | 'sms' => Boolean(cm)),
        })),
        groups: Object.values(alert.groups).map((group) => ({
          id: group.groupId,
          name: group.name,
          alertsContactMethods: [
            group.contactViaEmail ? 'email' : null,
            group.contactViaSMS ? 'sms' : null,
          ].filter((cm): cm is 'email' | 'sms' => Boolean(cm)),
          contacts: Object.values(group.contactsForGroup).map((contact) => ({
            id: contact.contactId,
            name: contact.name,
            email: contact.email,
            sms: contact.sms,
          })),
        })),
        startDate: alert.startDate,
        endDate: alert.endDate,
        createdAt: alert.createdAt,
        updatedAt: alert.updatedAt,
        deletedAt: alert.deletedAt,
        insect: alert.insectId ? { id: alert.insectId } : undefined,
        notifyOwnerByEmail: alert.notifyOwnerByEmail,
        notifyOwnerBySMS: alert.notifyOwnerBySMS,
        snoozeUntil: alert.snoozeUntil,
        snoozeAllUntil: alert.snoozeAllUntil,
        sleepMinutes: alert.sleepMinutes,
        frequencyMinutes: alert.frequencyMinutes ?? AlertsSettings.frequencyMinutesDefault[alert.alertType],
        repeatAnnually: false, // Legacy alerts do not have this field
      }
    })
  }

  return v3Alerts
}
